import approvedImage from './images/approved.svg';
import confirmedImage from './images/confirmed.svg';
import draftsImage from './images/drafts.svg';
import rejectedImage from './images/rejected.svg';
import requestedImage from './images/requested.svg';
import type { ScopeConfig } from './types';
import { BookingScope } from './types';

export const scopeConfigs: ScopeConfig[] = [
  { image: requestedImage, kpiField: 'requested', label: 'Requested', scope: BookingScope.REQUESTED },
  { image: approvedImage, kpiField: 'approved', label: 'Approved', scope: BookingScope.APPROVED },
  { image: confirmedImage, kpiField: 'confirmed', label: 'Confirmed', scope: BookingScope.CONFIRMED },
  { image: rejectedImage, kpiField: 'rejected', label: 'Rejected', scope: BookingScope.REJECTED },
  { image: draftsImage, kpiField: 'drafts', label: 'Drafts', scope: BookingScope.DRAFTS }
];
